import React from "react";
import { useSite, waLink } from "../context/SiteContext";

export default function FloatingWhatsApp() {
    const { site } = useSite();
    const number = site?.socials?.whatsapp_default || site?.contact?.phones?.[0]?.waNumber || "22398842679";
    return (
        <a
            href={waLink(number, "Bonjour GAB'S SERVICES, je souhaite obtenir des informations.")}
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp"
            aria-label="WhatsApp"
            className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-xl flex items-center justify-center transition-transform hover:scale-105"
        >
            <svg viewBox="0 0 32 32" className="w-7 h-7 fill-current" aria-hidden="true">
                <path d="M19.11 17.59c-.27-.14-1.59-.78-1.83-.87-.25-.09-.43-.13-.61.14-.18.27-.7.86-.86 1.04-.16.18-.32.2-.59.07-.27-.14-1.13-.42-2.16-1.33-.8-.71-1.34-1.6-1.5-1.87-.16-.27-.02-.41.11-.55.12-.12.27-.32.4-.48.13-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.46l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.63 1.11 2.81.14.18 1.93 2.95 4.69 4.13.66.29 1.18.46 1.58.59.66.21 1.26.18 1.74.11.53-.08 1.59-.65 1.81-1.28.22-.63.22-1.17.16-1.28-.07-.11-.25-.18-.52-.32zM16.04 4C9.95 4 5 8.93 5 15c0 1.92.5 3.79 1.45 5.44L5 27l6.71-1.41a11.04 11.04 0 0 0 4.33.88c6.09 0 11.04-4.93 11.04-11s-4.95-11-11.04-11zm0 20a8.97 8.97 0 0 1-4.58-1.25l-.33-.2-3.98.84.85-3.89-.22-.34A8.97 8.97 0 1 1 25.04 15c0 4.96-4.04 9-9 9z" />
            </svg>
        </a>
    );
}
